import DefaultLayout from "@/views/Layout/DefaultLayout";
import i18n from "@/i18n.js";

const landLeasesMenu = {
    path: "/land-leases",
    name: "LandLease",
    component: DefaultLayout,
    meta: {
        title: i18n.t("title.land_leases")
    },
    children: [
        {
            path: "index",
            name: "LandLeaseIndex",
            component: () => import("@/views/LandLeases/VIndex"),
            meta: {
                title: i18n.t("title.land_leases")
            }
        }
    ]
};

export default landLeasesMenu;
